import 'bootstrap/dist/js/bootstrap'
import $ from 'jquery'

const suiPageHeader = () => {
  $('.sui-header-toggle')
    .attr('data-toggle', 'collapse')
    .attr('data-target', '.sui-header-content')
    .attr('aria-controls', 'sui-header-content')
    .attr('aria-expanded', false)
    .attr('aria-label', 'Navigation anzeigen')
    .attr('data-cy', 'header-hamburger')
    .addClass('hamburger hamburger--squeeze')
    .append('<span class="hamburger-box"><span class="hamburger-inner"></span></span>')

  const headerContent = $('.sui-header-content')
  headerContent
    .on('show.bs.collapse', () => {
      $('.sui-header-toggle').addClass('is-active')
    })
    .on('hide.bs.collapse', () => {
      $('.sui-header-toggle').removeClass('is-active')
    })
}

document.addEventListener('DOMContentLoaded', () => suiPageHeader())
